import { useQuery } from "@tanstack/react-query";

import { getSoilSightCoverCropTiming } from "services";

import { useIsAuthenticated } from "utils";

import { GET_SOIL_SIGHT_COVER_CROP_TIMING } from "consts";

import { SoilSightCoverCropTiming } from "models";

/** Keyed by field and model version: the field's climate region and the model's rules decide the timing. */
export const useGetSoilSightCoverCropTiming = (
  soilSightProjectId: string | null,
  fieldId: string | null,
  silverServiceVersion: string | null,
  isEnabled = true
) => {
  const isAuthenticated = useIsAuthenticated();

  return useQuery<SoilSightCoverCropTiming>({
    queryKey: [GET_SOIL_SIGHT_COVER_CROP_TIMING, soilSightProjectId, fieldId, silverServiceVersion],
    queryFn: () => getSoilSightCoverCropTiming(soilSightProjectId ?? ""),
    staleTime: Infinity, // one field on one model version always has the same region and rules
    enabled: isEnabled && isAuthenticated && !!soilSightProjectId && !!fieldId,
  });
};
